import React from 'react';
import moment from 'moment';
import events from 'lib/events';
import {dateTimeFormats} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import Step from './step.jsx';

class Container extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {};

  getActivity = time => {
    let {formatMessage} = this.props.intl;

    if (time === null) {
      return null;
    }

    if (!time.isValid()) {
      return null;
    }

    let lastUpdatedTime = moment().diff(time, 'hours') * -1;

    lastUpdatedTime = lastUpdatedTime < 0 ? lastUpdatedTime * -1 : lastUpdatedTime;

    if (lastUpdatedTime <= 48) {
      return formatMessage({id: 'integrations.sync.status'}) + ': ' + formatMessage({id: 'general.active'});
    }

    return formatMessage({id: 'integrations.earliest.purchase.record'}) + ': ' + time.local().format(dateTimeFormats.numeralDateTime);
  };

  copyAPIKey = () => {
    const elem = document.getElementById('apiKey');

    const targetId = '_hiddenCopyText_';
    const isInput = elem.tagName === 'INPUT' || elem.tagName === 'TEXTAREA';
    let origSelectionStart, origSelectionEnd;

    if (isInput) {
      // can just use the original source element for the selection and copy
      target = elem;
      origSelectionStart = elem.selectionStart;
      origSelectionEnd = elem.selectionEnd;
    } else {
      // must use a temporary form element for the selection and copy
      target = document.getElementById(targetId);
      if (!target) {
        var target = document.createElement('textarea');

        target.style.position = 'absolute';
        target.style.left = '-9999px';
        target.style.top = '0';
        target.id = targetId;
        document.body.appendChild(target);
      }
      target.textContent = elem.textContent;
    }
    // select the content
    const currentFocus = document.activeElement;

    target.focus();
    target.setSelectionRange(0, target.value.length);

    // copy the selection
    let succeed;

    try {
      succeed = document.execCommand('copy');
    } catch (e) {
      succeed = false;
    }
    // restore original focus
    if (currentFocus && typeof currentFocus.focus === 'function') {
      currentFocus.focus();
    }

    if (isInput) {
      // restore prior selection
      elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
      // clear temporary content
      target.textContent = '';
    }
    return succeed;
  };

  openConfirmationModal = () => {
    events.publish('integrations-confirmation-modal');
  };

  render() {
    let showKey = 'hide-component';
    let showSteps = '';
    let showInputKey = 'hide-component';
    let {formatMessage} = this.props.intl;

    if (this.props.isActive && this.props.showApiKeyContainer) {
      showKey = 'row cb-api-key-container';
    }

    if (this.props.showSteps !== null && this.props.showSteps !== undefined && !this.props.showSteps) {
      showSteps = 'hide-component';
    }

    if (this.props.showInputKey) {
      showInputKey = 'row cb-api-key-container';
    }

    const steps = this.props.steps.map((step, i) =>
      <Step number={i + 1}
            key={i}
            message={step}
            showArrow={i < this.props.steps.length - 1}/>
    );

    const handleActivationButton = () => {
      // Allow if activation enable or if is currently active and is being clicked for desactive
      if((this.props.activationEnabled || this.props.isActive) && this.props.openModalConfirm) {
        this.props.openModalConfirm();
      }
    };

    return (
      <div>
        <div className='box-section'>
          <div className='row rb-control'>
            <div className='col-sm-9'>
              <h2>{this.props.title} </h2>
              {this.props.isActive ? <p><i className='dot green-dot'/><FormattedMessage id='general.activated'/></p> :
              <p><i className='dot red-dot'/><FormattedMessage id='general.deactivated'/></p>}
              <p dangerouslySetInnerHTML={{__html: this.props.description}}></p>
            </div>
            <div className='col-sm-3 pull-right'>
              <a className='blue-button rb-margin-bottom-action'
                 onClick={handleActivationButton} disabled={!this.props.activationEnabled && !this.props.isActive}>{this.props.isActive ?
                formatMessage({id: 'general.deactivate'}) :
                formatMessage({id: 'general.activate'})}</a>
            </div>
          </div>
          <div className={showSteps}>
            <div className='gray-line'/>
            <div className='row rbc-steps'>
              {steps}
            </div>
          </div>
          <div className={showKey}>
            <span className='highlighted-text'><FormattedMessage id='general.api.key'/>:&ensp;&ensp;&ensp;</span>
            <span id='apiKey'>{this.props.apiKey}</span>
            <a className='blue-button api-button'
               onClick={this.copyAPIKey}><FormattedMessage id='general.copy'/></a>
            <p className='api-text-margin-top highlighted-text'>{this.getActivity(this.props.lastPOSActivity)}</p>
          </div>
          <div className={showInputKey}>
            <p className='api-text-margin-bottom'><FormattedMessage id='integrations.api.key.description'/></p>
            <span className='highlighted-text'><FormattedMessage id='general.api.key'/>:&ensp;&ensp;&ensp;</span>
            <input type='text'/>
            <div className='container-fluid sync-container'>
              <div className='row'>
                <div className='col-sm-10'>
                  <p className='api-text-margin-top highlighted-text'>
                    <FormattedMessage id='integrations.status'/>:&ensp;&ensp;
                    <FormattedMessage id='integrations.in.progress'/></p>
                </div>
                <div className='col-sm-2 pull-right'>
                  <a className='blue-button'>Sync</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(Container);
